export const advisorContactCardImage = ({advisorContactCard, defaultImage}) => (
  advisorContactCard.get('avatar-url') ||
    advisorContactCard.get('firm-logo-url') ||
    defaultImage
)
